import React from 'react';
import debounce from 'lodash.debounce';

class LettersGrid extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            scale: 0,
            opacity: 0
        };
        
        this.ratioW = window.innerWidth / window.innerHeight;
        this.ratioH = window.innerHeight / window.innerWidth;
        this.string = ['v','i','v','i','a','n','e','.','k','o','r','k','m','a','z','@','g','m','a','i','l','.','c','o','m'];

        this.onResize = this.onResize.bind(this);
        this.onInteractionMove = this.onInteractionMove.bind(this);
        this.onInteractionMoveEnd = debounce(this.onInteractionMoveEnd.bind(this), 1000);
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
        window.addEventListener('mousemove', this.onInteractionMove);
        window.addEventListener('mousemove', this.onInteractionMoveEnd);
        window.addEventListener('touchmove', this.onInteractionMove);
        window.addEventListener('touchmove', this.onInteractionMoveEnd);
    }
    
    componentWillUnmount() {
        this.onInteractionMoveEnd.cancel();
        
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('mousemove', this.onInteractionMove);
        window.removeEventListener('mousemove', this.onInteractionMoveEnd);
        window.removeEventListener('touchmove', this.onInteractionMove);
        window.removeEventListener('touchmove', this.onInteractionMoveEnd);
    }

    // onMouseMove(e) {
    //     let scaleCircle = 1.5;
    //     let rayon = Math.max(window.innerWidth * scaleCircle, window.innerHeight * scaleCircle) / 2;
    //     let distW = Math.sqrt(Math.pow(e.pageY - window.innerHeight / 2, 2) * this.ratioW + Math.pow(e.pageX - window.innerWidth / 2, 2));
    //     let distH = Math.sqrt(Math.pow(e.pageY - window.innerHeight / 2, 2) + Math.pow(e.pageX - window.innerWidth / 2, 2) * this.ratioH);
    //     let scale = 0;
        
    //     if(window.innerWidth >= window.innerHeight) {
    //         scale = 1 - distW / rayon;
    //     }
    //     else {
    //         scale = 1 - distH / rayon;
    //     }

    //     scale = Math.max(scale, 0.15);
    //     scale = Math.min(scale, 1);

    //     this.setState({scale: scale, opacity: 1});
    // }

    onInteractionMove(e) {
        let x = 0;
        let y = 0;

        if(e instanceof MouseEvent) {
            x = e.pageX;
            y = e.pageY;
        }
        else {
            x = e.changedTouches[0].pageX;
            y = e.changedTouches[0].pageY;
        }

        let scaleCircle = 1.5;
        let rayon = Math.max(window.innerWidth * scaleCircle, window.innerHeight * scaleCircle) / 2;
        let distW = Math.sqrt(Math.pow(y - window.innerHeight / 2, 2) * this.ratioW + Math.pow(x - window.innerWidth / 2, 2));
        let distH = Math.sqrt(Math.pow(y - window.innerHeight / 2, 2) + Math.pow(x - window.innerWidth / 2, 2) * this.ratioH);
        let scale = 0;
        
        if(window.innerWidth >= window.innerHeight) {
            scale = 1 - distW / rayon;
        }
        else {
            scale = 1 - distH / rayon;
        }

        scale = Math.max(scale, 0.15);
        scale = Math.min(scale, 1);

        if(!document.body.classList.contains('letters-grid-displayed')) {
            document.body.classList.add('letters-grid-displayed');
        }

        this.setState({scale: scale, opacity: 1});
    }

    onInteractionMoveEnd(e) {
        if(document.body.classList.contains('letters-grid-displayed')) {
            document.body.classList.remove('letters-grid-displayed');
        }
        
        this.setState({opacity: 0});
    }

    onResize() {
        this.ratioW = window.innerWidth / window.innerHeight;
        this.ratioH = window.innerHeight / window.innerWidth;
    }

    render() {
        return (
            <div ref={this.lettersContainer} className="letters-container" style={{opacity: this.state.opacity}}>
                {this.string.map((letter, index) => <div key={index} className="letter-wrapper"><div className="letter barlow-bl-it red" style={{transform: `scale(${this.state.scale})`}}>{letter}</div></div>)}
            </div>
        );
    }
}

export default LettersGrid;


// WEBPACK FOOTER //
// ./src/components/LettersGrid.js